import { Services, regExp } from '@sigma-frontend-libs/commons'

import { components, labelModes, permissionPresets } from '@/utils'

import buttonFilter from '@/components/button/filter'
import filterDate from '@/components/filter/date'
import squircle from '@/components/icon/squircle'
import selectorOwner from '@/components/selector/owner'
import { invoiceStatues, statusColors, statusIcons } from '@/components/services/invoices/utils'

function renderDateFilter(h) {
  return h(
    filterDate,
    {
      props: {
        value: this.proxy.createdAt,
        preset: this.proxy.createdAtPreset,
        presets: true,
        backendGeneration: 'nest'
      },
      on: {
        input: event => {
          this.proxy.createdAt = event
        },
        preset: event => {
          this.proxy.createdAtPreset = event
        }
      }
    }
  )
}

function renderDocNumber(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.docNumber,
        label: this.getTranslate(`${Services.invoices}.labels.docNumber`),
        labelMode: labelModes.hidden,
        dense: true,
        clearable: true,
        details: false,
        mask: regExp.digits
      },
      on: {
        input: event => {
          this.proxy.docNumber = event
        }
      }
    }
  )
}

function renderStatus(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.status,
        label: this.getTranslate(`${Services.invoices}.labels.status`),
        items: invoiceStatues.map(status => {
          return {
            title: this.getTranslate(`${Services.invoices}.labels.statuses.${status}`),
            value: status
          }
        }),
        labelMode: labelModes.hidden,
        dense: true,
        clearable: true,
        details: false
      },
      scopedSlots: {
        item: ({ item }) => {
          return h(
            'div',
            {
              class: `${Services.invoices}-filter__status`
            },
            [
              h(
                squircle,
                {
                  props: {
                    icon: statusIcons[item.value],
                    color: statusColors[item.value]
                  }
                }
              ),
              this.getTranslate(`${Services.invoices}.labels.statuses.${item.value}`)
            ]
          )
        }
      },
      on: {
        input: event => {
          this.proxy.status = event
        }
      }
    }
  )
}

function renderCustomer(h) {
  if (this.checkPermissions('advanced.users.get', permissionPresets.resellerUp)) {
    return h(
      selectorOwner,
      {
        props: {
          value: this.proxy.customerId,
          label: this.getTranslate(`${Services.invoices}.labels.customer`),
          labelMode: labelModes.hidden,
          dense: true
        },
        on: {
          input: event => {
            this.proxy.customerId = event
          }
        }
      }
    )
  }
}

function renderOwner(h) {
  if (this.checkPermissions('advanced.users.get', permissionPresets.resellerUp)) {
    return h(
      selectorOwner,
      {
        props: {
          value: this.proxy.ownerId,
          label: this.getTranslate(`${Services.invoices}.labels.owner`),
          labelMode: labelModes.hidden,
          dense: true
        },
        on: {
          input: event => {
            this.proxy.ownerId = event
          }
        }
      }
    )
  }
}

function renderRequisite(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.requisiteId,
        label: this.getTranslate(`${Services.invoices}.labels.requisite`),
        service: Services.requisites,
        labelMode: labelModes.hidden,
        dense: true,
        clearable: true,
        autocomplete: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.requisiteId = event
        }
      }
    }
  )
}

function renderCompany(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.companyId,
        label: this.getTranslate(`${Services.invoices}.labels.company`),
        service: Services.companies,
        labelMode: labelModes.hidden,
        dense: true,
        clearable: true,
        autocomplete: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.companyId = event
        }
      }
    }
  )
}

function renderFields(h) {
  return [
    renderStatus.call(this, h),
    renderCustomer.call(this, h),
    renderOwner.call(this, h),
    renderRequisite.call(this, h),
    renderCompany.call(this, h)
  ]
}

function renderButtonFilter(h) {
  return h(
    buttonFilter,
    {
      props: {
        value: this.proxy,
        defaultValue: this.defaultFilter
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    renderFields.call(this, h)
  )
}

function renderContentByViewport(h) {
  if (this.viewport.breakpoint.lgUp) {
    return renderButtonFilter.call(this, h)
  } else {
    return renderFields.call(this, h)
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.invoices}-filter`
    },
    [
      renderDateFilter.call(this, h),
      renderDocNumber.call(this, h),
      renderContentByViewport.call(this, h)
    ]
  )
}
